import { BackendEnum } from "../../backend/enums/BackendEnum"

interface SubscriberEntityOption {
    enum: SubscriberEntityPresence,
    description: string,
}

interface BackendInfo {
    enum: BackendEnum;
    description: string;
}

export enum SubscriberEntityPresence {
    All = 0,
    NotPresent = 1,
    Present = 2,
}

export class SubscriberForgottenListFilterFormModel {
    static getEntityOptions(ent: string):SubscriberEntityOption[] {
        return [
            {
                enum: SubscriberEntityPresence.All,
                description: `Todos`
            },
            {
                enum: SubscriberEntityPresence.NotPresent,
                description: `Sem ${ent}s`
            },
            {
                enum: SubscriberEntityPresence.Present,
                description: `Com pelo menos 1 ${ent}`
            },
        ]
    }

    static getBackendOptions():BackendInfo[] {
        return [
            {
                enum: BackendEnum.All,
                description: 'Todos',
            },
            {
                enum: BackendEnum.Shop,
                description: 'Shop',
            },
            {
                enum: BackendEnum.Bimer,
                description: 'Bimer',
            },
            {
                enum: BackendEnum.Interfacenet,
                description: 'Interfacenet',
            },
        ]
    }

    name: string = ""
    idExternal: string = ""
    lastUpdate: string = ""
    alias: string = ""
    days: number = 999
    invalidateCache: boolean = false    
    backend: BackendInfo = SubscriberForgottenListFilterFormModel.getBackendOptions()[0]
    productOption: SubscriberEntityOption = SubscriberForgottenListFilterFormModel.getEntityOptions('produto')[0]
    categoryOption: SubscriberEntityOption = SubscriberForgottenListFilterFormModel.getEntityOptions('categoria')[0]
    brandOption: SubscriberEntityOption = SubscriberForgottenListFilterFormModel.getEntityOptions('marca')[0]
    orderOption: SubscriberEntityOption = SubscriberForgottenListFilterFormModel.getEntityOptions('pedido')[0]

    constructor(s?:Partial<SubscriberForgottenListFilterFormModel>) {
        Object.assign(this, s)
    }

    isFilterFilled():boolean {
        return !!this.name ||
            !!this.idExternal ||
            !!this.alias ||
            !!this.days
    }
}
